import { ProviderWebsiteModel } from '../../../shared/models/provider-website-model';

import { Serializable } from '../../../core/models/serializable';

export class ChannelAnnouncementStatModel
  implements Serializable<ChannelAnnouncementStatModel>
{
  fromObject(obj: any): ChannelAnnouncementStatModel {
    Object.assign(this, obj);
    this.channel = null;

    if (obj.channel != null) {
      let t = new ProviderWebsiteModel();
      t = t.fromObject(obj.channel);
      this.channel = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public totalCount: number;
  public uniqueCount: number;
  public countPerChannel: number;
  public channel: ProviderWebsiteModel;
  public suitableForStudentsAnnouncementsCount: number;
}
